export default __webpack_public_path__ + "82913720419bf22511f0987482db84e1.svg";